import React, { useContext, useState } from 'react';

import { AlertaContexto, useToast } from '.';

export interface Props {
    titulo?: string;
    conteudo: string;
    aoConfirmar: () => void;
}

const Confirmacao = ({ titulo, conteudo, aoConfirmar }: Props): React.ReactElement =>
{
    const toast = useToast();
    const { setConfirmacao } = useContext(AlertaContexto);
    const [ processando, setProcessando ] = useState<boolean>(false);

    const confirmar = async (): Promise<void> =>
    {
        try {
            setProcessando(true);

            await aoConfirmar();

            setConfirmacao(null);
        } catch (erro) {
            toast({
                titulo: 'Erro',
                conteudo: 'Verifique os logs para mais detalhes.',
                tema: 'danger',
            });
        }
    }

    return (
        <React.Fragment>
            <div className="modal show animate__animated animate__fadeIn animate__faster d-block"  style={{ zIndex: 2500 }}>
                <div className="modal-dialog modal-sm modal-dialog-centered p-3 p-sm-0">
                    <div className="modal-content border-0">
                        { titulo && (
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    { titulo }
                                </h5>
                            </div>
                        ) }
                        <div className="modal-body">
                            { conteudo }
                        </div>
                        <div className="modal-footer flex-column border-0">
                            <button
                                className={ `btn btn-primary m-0 w-100 ${processando ? 'disabled' : ''}` }
                                onClick={ confirmar }
                            >
                                <React.Fragment>
                                    { processando && (
                                        <React.Fragment>
                                            <span className="spinner-border spinner-border-sm me-2"></span>
                                            Aguarde...
                                        </React.Fragment>
                                    ) }
                                    { !processando && 'Confirmar' }
                                </React.Fragment>
                            </button>
                            <button
                                className={ `btn btn-light m-0 mt-2 w-100 ${processando ? 'disabled' : ''}` }
                                onClick={ () => setConfirmacao(null) }
                            >
                                Cancelar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop show animate__animated animate__fadeIn animate__faster" style={{ zIndex: 2000 }}></div>
        </React.Fragment>
    )
}

export default Confirmacao;
